<template>
    <div class="result">
        <div class="box_bg clearfix">
            <div :class="type==2?'left_box-div1':'left_box-div2'">
                <p class="number">{{finish}}人</p>
                <p class="note">已完成</p>
            </div>
            <div :class="type==2?'left_box-div1':'left_box-div2'">
                <p class="number">{{unfinish}}人</p>
                <p class="note">未完成</p>
                <p class="urge"
                   :class="{'disabled_btn':!stu_info.length}"
                   @click="urges">催促</p>
            </div>
            <div :class="type==2?'left_box-div1':'left_box-div2'"
                 v-if="type==2">
                <p class="number">{{wrong_num}}人</p>
                <p class="note">未订正</p>
                <p class="urge"
                   :class="{'disabled_btn':!stu_info.length}"
                   @click="revision">催促</p>
            </div>
        </div>
        <div class="stu_list">
            <h3>
                <span>学生情况</span>
                <div v-if='type==2'
                     class='list_box-tips'></div>
                <!-- <a href="javascript:;" v-if="city!=411600">写评语</a> -->
            </h3>
            <div :class="[type==1?'list title repeat':'list title']">
                <div class="name">姓名</div>
                <div class="result"
                     v-if="type==1">
                    <span>课文跟读</span>
                    <span>单词跟读</span>
                </div>
                <div class="result"
                     v-else>成绩</div>
                <div class="time">提交时间</div>
            </div>
            <template v-if="stu_info.length">
                <div :class="[type==1?'list repeat':'list']"
                     @click="toNom(stu)"
                     v-for="stu in stu_info">
                    <div class="name"><span>{{stu.real_name}}</span><i v-if="stu.status===2&&stu.is_delay"></i></div>
                    <div class="result"
                         v-if="type==1">
                        <span :class="{'orange':stu.r_text&&stu.status===2}">{{stu.r_text&&stu.status===2?stu.r_text:stu.r_word&&stu.status===2?'--':'未完成'}}</span>
                        <span :class="{'orange':stu.r_word&&stu.status===2}">{{stu.r_word&&stu.status===2?stu.r_word:stu.r_text&&stu.status===2?'--':'未完成'}}</span>
                    </div>
                    <div class="result"
                         v-else>
                        <span :class="{'orange':stu.status===2}">{{stu.status===2?Math.floor(stu.score)+'分':'未完成'}}</span>
                        <em v-if="stu.wrong_status&&stu.score<100"
                            class='p_revision'></em>
                    </div>
                    <div class="time"
                         v-if="stu.add_date&&stu.status===2">
                        {{stu.add_date | dateFormat('MM月DD日 hh:mm')}}
                        <i></i>
                    </div>
                    <div class="time"
                         v-else>--</div>
                </div>
            </template>

            <div class="noresources"
                 v-else>
                <p>当前班级暂无学生</p>
            </div>
        </div>

        <div id="layui-m-layer"
             class="layui-m-layer layui-m-layer0"
             v-if='urge'>
            <div class="layui-m-layershade"></div>
            <div class="layui-m-layermain">
                <div class="layui-m-layersection">
                    <div class="layui-m-layerchild  layui-m-anim-scale">
                        <div class="title_container">
                            <span @click="send_qun"
                                  :class="{'title_on':send_Type=='qun'}"
                                  class="lay_title lay_title1">发到家长群</span>
                            <span @click="send_msg"
                                  :class="{'title_on':send_Type=='msg'}"
                                  class="lay_title lay_title2"
                                  v-if="platform_id=='410000'">发送短信<span class="title_tip">（仅发送开通用户）</span></span>
                        </div>
                        <textarea class="textar"
                                  ref="textar"
                                  v-bind:maxlength="200"
                                  @input="info1"
                                  v-model='information1'></textarea>
                        <div class="layui-m-layerbtn">
                            <span @click='cancel'>取消</span>
                            <span @click='release'
                                  v-if="send_Type=='qun'">发到家长群里</span>
                            <span @click='release2'
                                  v-if="send_Type=='msg'">发送短信</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            send_Type: 'qun',
            urge: false,
            information1: '你的作业完成了吗？不可以对自己降低要求哟！因为你能做到更好！',
            sid: 9,
            tbkt_Token: localStorage.getItem("Tbkt-Token"),
            city_id: localStorage.getItem('city_id'),
            platform_id: localStorage.getItem('platform_id'),
            isSend: true,//防止连点
            category: 0,// type 1 催促未做完 2 催促个性化学习 3 催促错题订正
            is_edit: 0,
            task_name: this.$route.query.task_name,
            begin_date: this.$route.query.begin_date,
            informationObj: {},
            sms_id: 0,
        }
    },
    props: ['type', 'city', 'finish', 'unfinish', 'stu_info', 'classId', 'message_id', 'isActive', "wrong_num"],
    components: {},
    methods: {
        revision () {
            if (this.stu_info.length) {
                this.category = 1;
                this.send_Type = 'qun';
                if (Number(this.wrong_num)) {
                    this.getSmsContent();
                } else {
                    layer.tips('所有学生都已完成');
                }
            }
        },
        getSmsContent () {
            this.$store.dispatch('urge_content', {
                'sid': Number(this.$route.params.sid),
                'task_type': this.task_name,
                'begin_date': Number(this.begin_date),
                'type': this.category ? 3 : 1
            }).then((res) => {
                let _res = res.data.data;
                this.sms_id = _res.sms_id;
                this.informationObj[this.category][1] = _res.content;
                this.information1 = this.informationObj[this.category][0];
                this.is_edit = 0;
                this.urge = !this.urge;
            })
        },
        send_qun () {
            this.send_Type = 'qun';
            this.information1 = this.informationObj[this.category][0];
        },
        send_msg () {
            this.send_Type = 'msg';
            this.information1 = this.informationObj[this.category][1];
        },
        urges () {
            if (this.stu_info.length) {
                this.category = 0;
                this.send_Type = 'qun';
                if (Number(this.unfinish)) {
                    //写评语
                    this.getSmsContent();
                } else {
                    layer.tips('所有学生都已完成')
                }
            }
        },
        info1 () {
            var textVal = this.information1.length;
            if (this.send_Type == 'msg') {
                this.is_edit = 1;
            }
            if (this.information1.length >= 200) {
                layer.tips('已经超过200字了')
            }
        },
        toNom (stu) {
            if (stu.add_date && stu.status === 2) {
                //个人
                this.$emit('child', stu);
            }
        },
        cancel () {
            this.is_edit = 0;
            this.urge = !this.urge
        },
        release2 () {//发送短信
            if (!this.isSend) {
                return false;
            }
            this.isSend = false;
            let this_ = this;
            let stu_user_id = [];
            this.stu_info.forEach(item => {
                if ((!item.status || item.status == 1) && !this.category) {
                    stu_user_id.push(item.user_id)
                }
                if (this.category && item.score < 100 && item.wrong_status) {
                    stu_user_id.push(item.user_id)
                }
            });
            let { real_name } = JSON.parse(localStorage.getItem('info'));
            // let content = this.informationObj[this.category][1];
            this.$http.post(API_URL_TASK_API + '/public/task/urge', {
                message_id: this_.message_id,
                unit_class_id: this_.classId,
                sid: this_.$route.params.sid,
                stu_user_id: stu_user_id.join(','),
                type: this.category ? 3 : 1,
                content: this.information1,
                task_type: this.task_name,
                begin_date: Number(this.begin_date),
                is_edit: this.is_edit,
                sms_id: this.sms_id,
                place_id: this.category ? 28 : 29,//配置平台发送短信配置参数
            }).then(res => {
                // //console.log(res)
                this.isSend = true;
                if (res.data.response == 'ok') {
                    this_.urge = false;
                    layer.tips("发送成功！");
                } else {
                    layer.tips("发送失败！");
                }
            })
        },
        release () {
            let that=this
            // if(!this.isSend){
            //     return false;
            // }
            // this.isSend=false;
            this.information1 = this.information1.replace(/(^\s*)|(\s*$)/g, "");
            this.information1 = this.information1.replace(/,/g, '，');
            if (this.information1.length > 200) {
                layer.tips('已经超过200字了');
                return false
            } else if (this.information1 == 0) {
                layer.tips('内容为空');
                return false
            }
            this.$http.post(API_URL_TASK_API + '/public/task/tea/share/in', {
                message_id: this.message_id,
                unit_class_id: this.classId,
                content: this.information1,
                type: this.category ? 2 : 0
            }).then(res => {
                // this.isSend=true;
                if (res.data.response == 'ok') {
                    this.urge = false;
                    let id = res.data.data.id;
                    let content = res.data.data.content;
                    let url = VUE_URL_HD;
                    let sid = this.$route.params.sid
                    if (this.category) {
                        url += `/#/share/wrongTask?sid=${sid}&unit_class_id=${this.classId}&message_id=${this.message_id}&id=${id}&tbkt_token=${this.tbkt_Token}`;
                    } else {
                        url += `/#/share/examine_task?sid=${sid}&type=0&id=${id}&tbkt_token=${this.tbkt_Token}`;
                    }
                    let title = `同步课堂`;
                    if (this.city_id == "411600") {
                        title = "随堂练";
                    }
                    // try {
                    //     appobject.Interactive(`ys_share,${title},${this.information1},${url}`)
                    // } catch (e) {
                    //     //console.log(`ys_share,${title},12号作业,${url}`)
                    // }
                    if(this.inApp){
                        this.appFunction("ys_share", `${title},${this.information1},${url},${sid},${this.classId},0,0,教师检查作业催促发送到群里`);
                    }else{
                        let coptText=`${title},${this.information1},链接：${url}`
                        layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                            layer.close(index)
                           that.copyText(coptText);
                        }, '分享链接复制成功')
                    }
                    // layer.tips("发送成功！");
                }
            })
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    },
    created () {
        this.informationObj = {
            0: [
                `（${this.getSmsdate(this.begin_date)}）英语的${this.task_name}作业以下孩子未完成，请尽快督促孩子完成。`,
                '',//接口获取
            ],
            1: [
                `（${this.getSmsdate(this.begin_date)}）英语的${this.task_name}作业以下孩子未完成错题订正，请尽快督促孩子完成订正。`,
                '',//接口获取
            ]
        }

    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.title_container {
    width: 93.4%;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 0.4rem;
}

.lay_title {
    color: #000000;
    text-align: center;
    padding: 0.25rem 0;
    float: left;
    font-size: 0.7rem;
    border-bottom: none;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    box-sizing: border-box;
}

.title_on {
    background-color: #f0f0f0;
}

.title_tip {
    color: red;
    font-size: 0.6rem;
}

.lay_title1 {
    width: 30%;
}

.lay_title2 {
    width: 70%;
}

.result {
    .box_bg {
        padding: 12px / $ppr 24px / $ppr;
        background: #fff;
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        justify-content: space-between;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        margin: 0 auto;
        div {
            float: left;
            padding-top: 44px / $ppr;
            height: 238px / $ppr;
            text-align: center;
            background-size: 100% 100%;
            box-sizing: border-box;
            &.left_box-div1 {
                width: 216px / $ppr;
                background: url(./img/icon_img_01.png) no-repeat;
                background-size: 100%;
            }
            &.left_box-div2 {
                width: 330px / $ppr;
                background: url(./img/icon_img_02.png) no-repeat;
                background-size: 100%;
            }
            // &:first-child {
            //     margin-right: 12px/$ppr;
            // }
            .number {
                font-size: 48px / $ppr;
                color: #ff6600;
                font-weight: bold;
            }
            .note {
                margin-top: 16px / $ppr;
                font-size: 24px / $ppr;
                color: #999;
            }
            .urge {
                margin-top: 32px / $ppr;
                font-size: 24px / $ppr;
                color: #5e89ef;
                &.disabled_btn {
                    color: #666 !important;
                }
            }
        }
    }
    .stu_list {
        margin: 24px / $ppr 0;
        background: #fff;
        .list_box-tips {
            width: 144px / $ppr;
            height: 66px / $ppr;
            background: url("../../math/img/icon_img_title.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 50%;
            right: 20px / $ppr;
            transform: translate(0, -50%);
        }
        h3 {
            padding: 0 24px / $ppr;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            position: relative;
            span {
                font-size: 36px / $ppr;
                color: #333;
            }
            a {
                float: right;
                font-size: 30px / $ppr;
                color: #5eb9ef;
            }
        }
        .list {
            display: flex;
            display: -webkit-flex;
            padding: 0 24px / $ppr;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            color: #999;
            border-top: 1px / $ppr solid #e8e8e8;
            &.title {
                color: #333;
            }
            .name {
                width: 200px / $ppr;
                box-sizing: border-box;
                span {
                    float: left;
                    display: block;
                    width: 150px / $ppr;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                i {
                    display: inline-block;
                    margin-left: 10px / $ppr;
                    width: 40px / $ppr;
                    height: 28px / $ppr;
                    background: url("./img/icon-delay.png") no-repeat;
                    background-size: 100% 100%;
                    vertical-align: middle;
                }
            }
            .result {
                width: 210px / $ppr;
                text-align: center;
                position: relative;
                .orange {
                    color: #ff6600;
                    margin-right: 5px / $ppr;
                }
                .p_revision {
                    display: inline-block;
                    width: 41px / $ppr;
                    height: 28px / $ppr;
                    background: url("./img/icon_img_03.png") no-repeat;
                    background-size: 100% 100%;
                    position: absolute;
                    top: 34px / $ppr;
                }
            }
            .time {
                flex: 1;
                -webkit-flex: 1;
                position: relative;
                padding-right: 20px / $ppr;
                text-align: center;
                i {
                    display: block;
                    position: absolute;
                    top: 50%;
                    right: 0;
                    margin-top: -14.5px / $ppr;
                    width: 16px / $ppr;
                    height: 29px / $ppr;
                    background: url("./img/icon-right.png") 0 0 no-repeat;
                    background-size: 100% 100%;
                }
            }
            &.repeat {
                .name {
                    width: 150px / $ppr;
                    span {
                        max-width: 100px / $ppr;
                    }
                }
                .result {
                    width: 280px / $ppr;
                    span {
                        box-sizing: border-box;
                        float: left;
                        display: inline-block;
                        width: 135px / $ppr;
                        text-align: center;
                    }
                }
            }
        }
        .noresources {
            border-top: 1px solid #e8e8e8;
            width: 100%;
            height: 300px / $ppr;
            p {
                line-height: 300px / $ppr;
                text-align: center;
            }
        }
    }
}

.layui-m-layerchild {
    text-align: center;
}

.textar {
    margin: auto 0;
    width: 86%;
    min-height: 200px / $ppr;
    margin: 30px / $ppr 0;
    margin-top: 0;
    background: #f0f0f0;
    border: none;
    padding: 20px / $ppr;
    border-bottom-left-radius: 10px / $ppr;
    border-bottom-right-radius: 10px / $ppr;
    font-size: 30px / $ppr;
}

.layui-m-layerbtn {
    border-top: 1px / $ppr solid #f0f0f0 !important;
    span {
        width: 50%;
        background: #fff;
    }
    span:nth-child(1) {
        border-right: 1px / $ppr solid #f0f0f0;
    }
    span:nth-child(2) {
        color: #5e89ef;
        border-right: 1px / $ppr solid #f0f0f0;
    }
}
</style>
